import React, { useEffect, useState } from "react";
import { useAdminAuth } from "../../../utils/useAuth";
import StatsCard from "./components/StatsCard";
import BookingStats from "./components/BookingStats";
import RecentBookings from "./components/RecentBookings";
import TopStats from "./components/TopStats";
import { getStats, getTableData } from "../../../api/admin/dashboardApi";

const Dashboard = () => {
  const { user, isAdmin } = useAdminAuth();
  const [Data, setData] = useState("");
  const [TableData, setTableData] = useState("");
  useEffect(() => {
    getStats(setData);
    getTableData(setTableData);
  }, []);
  return (
    <div className="space-y-5">
      <StatsCard Data={Data} />
      <BookingStats Data={Data} />
      <RecentBookings TableData={TableData} />
      <TopStats TableData={TableData} />
    </div>
  );
};

export default Dashboard;
